import React from "react";
import FanExperienceComponent from "../../Components/FanExperienceComponent/FanExperienceComponent";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

const FanExperience = () => {
  return (
    <div>
      <Header />
      <FanExperienceComponent />
      <Footer />
    </div>
  );
};

export default FanExperience;
